module.exports = __webpack_public_path__ + "static/img/6677_phase_function_Paper_Points.7905eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6677_phase_function_Paper_Points.png
// module id = Uy8z
// module chunks = 0